import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import { FileCheck, CreditCard } from 'lucide-react'
import AppBaqueiraHeader from '../containers/AppBaqueiraHeader'
import { withNamespaces } from "react-i18next"
import { postRedsys, fetchCustomer } from '../actions/qrs'
import StepBarBaqueira from '../components/StepBarBaqueira'

class PaymentBaqueiraView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      redsys: null,
      iva: 21,
      redsysSignature: null,
      redsysMerchant: null,
      redsysVersion: null,
      total: null,
      importeBase: null,
      importeIva: null,
      minutes: 5,
      seconds: 0,
      isTimeUp: false,
      showExitDialog: false,
      newLockerPrice: 0,
      discountApplied: false,
      timeStamp: null,
    }

    this._paymentSubmitted = false
    this._skipUnmountRedirect = false
    this._unblockHistory = null
    this.countdownInterval = null

    this.getLockerType = this.getLockerType.bind(this)
  }

  componentDidMount() {
    const {
      lockerPrice, prerentCode, startDate, endDate,
      qrType, qr, timeStamp, customerName, mail, phoneNumber,
      zoneSelected, descriptionZone, selectedLocker, lockerAssigned, appliedRule
    } = this.props.location.state

    const { i18n } = this.props

    let language = '001'
    switch (i18n.language) {
      case "es": language = '001'; break
      case "en": language = '002'; break
      case "it": language = '007'; break
      case "gr": language = '005'; break
      case "fr": language = '004'; break
      case "pt": language = '009'; break
    }

    // lockerPrice (LockersAmount) already includes any discount applied back in the
    // locker selector — charge it as-is; the original price is only reverse-calculated
    // for display in render().
    const discountPct = appliedRule && appliedRule.DiscountPercentage ? appliedRule.DiscountPercentage : 0
    const newLockerPrice = lockerPrice

    this.setState({ newLockerPrice, discountApplied: discountPct > 0 })
    this.setState({ timeStamp }, () => { this.startCountdown() })

    this._unblockHistory = history.block(() => {
      this.setState({ showExitDialog: true })
      return false
    })

    window.addEventListener('beforeunload', this._onBeforeUnload)

    const paymentId = Math.floor((Math.random() * 1000000) + 1).toString()

    const redsysURLOK = `https://lockers-qr.vacway.es/TicketBaqueiraView?lockerPrice=${newLockerPrice}&discountPct=${discountPct}&descriptionZone=${descriptionZone}&zoneSelected=${zoneSelected}&selectedLocker=${selectedLocker}&lockerAssigned=${lockerAssigned}&paymentId=${paymentId}&qrToken=${qr}&language=${i18n.language}&prerentCode=${prerentCode}&startDate=${startDate.toLocaleDateString()}&endDate=${endDate.toLocaleDateString()}&customerName=${encodeURIComponent(customerName)}&mail=${encodeURIComponent(mail)}&phoneNumber=${encodeURIComponent(phoneNumber)}`
    const redsysURLKO = `https://lockers-qr.vacway.es/PaymentBaqueiraError?qr=${qr}&language=${i18n.language}`

    const redsysPetition = {
      price: Number(newLockerPrice.toFixed(2)),
      redsysURLOK,
      redsysURLKO,
      paymentId,
      merchantCode: '351639505',
      currency: '978',
      terminal: '1',
      merchantUrl: 'https://vacway.com',
      secretKey: 'xhI+J4wrx0JKkeGqJ12j2+ErLNH9OpHM',
      language,
    }

    this.props.fetchCustomer('6669b7f41628a3b21f4ceaa0')
      .then((customer) => {
        redsysPetition.merchantCode = customer.response.Redsys.MERCHANTCODE
        redsysPetition.currency     = customer.response.Redsys.CURRENCY
        redsysPetition.terminal     = customer.response.Redsys.TERMINAL
        redsysPetition.merchantUrl  = customer.response.Redsys.MERCHANTURL
        redsysPetition.secretKey    = customer.response.Redsys.SECRETKEY

        return this.props.postRedsys(redsysPetition)
      })
      .then((answer) => {
        const answerRedsys = answer.response
        this.TotalComponent()
        this.setState({
          redsys: answerRedsys,
          redsysSignature: answerRedsys.Ds_Signature,
          redsysMerchant:  answerRedsys.Ds_MerchantParameters,
          redsysVersion:   answerRedsys.Ds_SignatureVersion,
        })
      })
      .catch((error) => { console.error(error) })
  }

  componentWillUnmount() {
    clearInterval(this.countdownInterval)
    if (this._unblockHistory) this._unblockHistory()
    window.removeEventListener('beforeunload', this._onBeforeUnload)

    if (!this._skipUnmountRedirect && !this._paymentSubmitted) {
      const { qr, lockerAssigned } = this.props.location.state
      history.push(`/qrsale/${qr}?lockerAssigned=${lockerAssigned}`)
    }
  }

  _onBeforeUnload = (e) => {
    if (!this._paymentSubmitted) {
      e.preventDefault()
      e.returnValue = ''
    }
  }

  startCountdown = () => {
    const startTime = new Date(this.state.timeStamp).getTime()
    const endTime = startTime + 5 * 60 * 1000

    this.countdownInterval = setInterval(() => {
      const diff = endTime - Date.now()
      if (diff <= 0) {
        clearInterval(this.countdownInterval)
        this.setState({ minutes: 0, seconds: 0, isTimeUp: true })
      } else {
        this.setState({
          minutes: Math.floor(diff / 60000),
          seconds: Math.floor((diff % 60000) / 1000),
        })
      }
    }, 250)
  }

  TotalComponent() {
    const { iva, newLockerPrice } = this.state
    const importeBase = (newLockerPrice / (1 + iva / 100)).toFixed(2)
    const importeIva  = (newLockerPrice - importeBase).toFixed(2)
    const total       = newLockerPrice.toFixed(2)
    this.setState({ importeBase, importeIva, total })
  }

  handleLeave() {
    this._skipUnmountRedirect = true
    if (this._unblockHistory) { this._unblockHistory(); this._unblockHistory = null }
    const { qr, lockerAssigned } = this.props.location.state
    history.push(`/qrsale/${qr}?lockerAssigned=${lockerAssigned}`)
  }

  goToPhoneView() {
    this._skipUnmountRedirect = true
    if (this._unblockHistory) { this._unblockHistory(); this._unblockHistory = null }
    const {
      zoneSelected, descriptionZone, selectedLocker, lockerPrice, lockerAssigned,
      prerentCode, prerentTime, totalDays, startDate, endDate, qrType, qr,
      timeStamp, selectedQuantity, customerId, appliedRule, customerName,
      phoneNumber, mail, idNumber, newsletterAcceptance, confirmReservation
    } = this.props.location.state
    this.props.push('/PhoneBaqueiraView', {
      zoneSelected, descriptionZone, selectedLocker, lockerPrice, lockerAssigned,
      prerentCode, prerentTime, totalDays, startDate, endDate, qrType, qr,
      timeStamp, selectedQuantity, customerId, appliedRule, customerName,
      phoneNumber, mail, idNumber, newsletterAcceptance, confirmReservation,
    })
  }

  getLockerType(type) {
    const { t } = this.props
    switch (type) {
      case "BNS":   return 'STANDARD'
      case "CNS":   return 'STANDARD CARGA'
      case "BWS":   return 'STANDARD XL'
      case "CWS":   return 'STANDARD CARGA XL'
      case "BNM":   return 'MEDIUM'
      case "CNM":   return 'MEDIUM CARGA'
      case "BWM":   return 'MEDIUM XL'
      case "CWM":   return 'MEDIUM CARGA XL'
      case "BNL":   return 'LARGE'
      case "CNL":   return 'LARGE CARGA'
      case "BWL":   return 'LARGE XL'
      case "CWL":   return 'LARGE CARGA XL'
      case "BN3XL": return t('2 Equipos de esquí')
      case "CN3XL": return t('3 Equipos de esquí')
      case "BW3XL": return t('4 Equipos de esquí')
      case "CW3XL": return t('3 Equipos de esquí sin secado')
      default:      return 'STANDARD'
    }
  }

  redsysForm() {
    const { redsys, redsysSignature, redsysMerchant, redsysVersion, newLockerPrice } = this.state
    const {
      descriptionZone, zoneSelected, selectedLocker, lockerAssigned,
      prerentCode, startDate, endDate, customerName, mail, phoneNumber, qr, qrType
    } = this.props.location.state
    const { t, i18n } = this.props

    const productionUrl = "https://sis.redsys.es/sis/realizarPago"
    const testUrl       = "https://sis-t.redsys.es:25443/sis/realizarPago"
    const paymentId     = Math.floor((Math.random() * 1000000) + 1).toString()

    const redsysURLOK = `https://lockers-qr.vacway.es/TicketBaqueiraView?descriptionZone=${descriptionZone}&zoneSelected=${zoneSelected}&selectedLocker=${selectedLocker}&lockerAssigned=${lockerAssigned}&lockerPrice=${newLockerPrice}&paymentId=${paymentId}&qrToken=${qr}&language=${i18n.language}&prerentCode=${prerentCode}&startDate=${startDate.toLocaleDateString()}&endDate=${endDate.toLocaleDateString()}&customerName=${encodeURIComponent(customerName)}&mail=${encodeURIComponent(mail)}&phoneNumber=${encodeURIComponent(phoneNumber)}`

    if (!redsys || !redsysSignature || !redsysMerchant || !redsysVersion) {
      return <div className="bq-spinner"><img src="/images/logo_baqueira.png" alt="Logo" /></div>
    }

    const markSubmitted = () => {
      this._paymentSubmitted = true
      this._skipUnmountRedirect = true
      if (this._unblockHistory) { this._unblockHistory(); this._unblockHistory = null }
    }

    const handleFreeClick = () => {
      markSubmitted()
      window.location.href = redsysURLOK
    }

    const action = qrType === 'test' ? testUrl : productionUrl
    const submitLabel = qrType === 'free' ? t('Reservar') : qrType === 'test' ? t('TEST') : t('Pagar')

    return (
      <div className="bq-pay-form-wrap">
        {qrType === 'free' ? (
          <form method="POST" acceptCharset="UTF-8" name="peticionRedsys">
            <input type="hidden" name="Ds_SignatureVersion"   value={redsysVersion} />
            <input type="hidden" name="Ds_MerchantParameters" value={redsysMerchant} />
            <input type="hidden" name="Ds_Signature"          value={redsysSignature} />
            <input type="button" value={submitLabel} className="bq-redsys-btn" onClick={handleFreeClick} />
          </form>
        ) : (
          <form action={action} method="POST" acceptCharset="UTF-8" name="peticionRedsys" onSubmit={markSubmitted}>
            <input type="hidden" name="Ds_SignatureVersion"   value={redsysVersion} />
            <input type="hidden" name="Ds_MerchantParameters" value={redsysMerchant} />
            <input type="hidden" name="Ds_Signature"          value={redsysSignature} />
            <input type="submit" value={submitLabel} className="bq-redsys-btn" />
          </form>
        )}
      </div>
    )
  }

  getTimerClass() {
    const { minutes, seconds } = this.state
    if (minutes === 0 && seconds < 60) return 'bq-timer bq-timer-urgent'
    if (minutes < 2) return 'bq-timer bq-timer-warning'
    return 'bq-timer'
  }

  renderTimeoutDialog() {
    const { t } = this.props
    return (
      <div className="bq-exit-overlay">
        <div className="bq-exit-dialog">
          <span className="bq-exit-dialog-icon">⏰</span>
          <h4 className="bq-exit-dialog-title">{t('Tiempo de reserva agotado')}</h4>
          <p className="bq-exit-dialog-body">
            {t('Lo sentimos, pero no podemos reservar tu taquilla por más tiempo, otros usuarios deben poder acceder a ella. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.')}
          </p>
          <div className="bq-exit-dialog-actions">
            <button className="bq-exit-btn-leave" onClick={() => this.handleLeave()}>
              {t('Volver al inicio')}
            </button>
          </div>
        </div>
      </div>
    )
  }

  renderExitDialog() {
    const { t } = this.props
    return (
      <div className="bq-exit-overlay">
        <div className="bq-exit-dialog">
          <span className="bq-exit-dialog-icon">🚪</span>
          <h4 className="bq-exit-dialog-title">{t('¿Cancelar la compra?')}</h4>
          <p className="bq-exit-dialog-body">
            {t('Si sales ahora perderás la pre-reserva de taquillas. La selección se liberará automáticamente.')}
          </p>
          <div className="bq-exit-dialog-actions">
            <button className="bq-exit-btn-stay" onClick={() => this.setState({ showExitDialog: false })}>
              {t('Continuar con el pago')}
            </button>
            <button className="bq-exit-btn-leave" onClick={() => this.handleLeave()}>
              {t('Salir')}
            </button>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { t } = this.props
    const { redsys, iva, importeBase, importeIva, total, minutes, seconds, isTimeUp, discountApplied, newLockerPrice, showExitDialog } = this.state
    const {
      descriptionZone, selectedLocker, lockerAssigned, startDate, endDate,
      customerName, mail, phoneNumber, selectedQuantity, appliedRule
    } = this.props.location.state

    // newLockerPrice is the final (already-discounted) amount. Reverse-calc the original
    // price for display only, so we never re-apply the discount to what's charged.
    const discountPct = appliedRule && appliedRule.DiscountPercentage ? appliedRule.DiscountPercentage : 0
    const originalPrice = discountPct > 0 ? (newLockerPrice / (1 - discountPct / 100)) : newLockerPrice
    const discountAmount = originalPrice - newLockerPrice

    if (!redsys) {
      return (
        <div className="baqueiraBackground">
          <AppBaqueiraHeader />
          <div className="nm-page">
            <div className="bq-spinner">
              <img src="/images/logo_baqueira.png" alt="Logo" />
            </div>
          </div>
          <StepBarBaqueira step={4} />
        </div>
      )
    }

    const lockerCount = selectedQuantity || (typeof lockerAssigned === 'string'
      ? lockerAssigned.split(',').filter(Boolean).length
      : (lockerAssigned && lockerAssigned.length) || 1)

    return (
      <div className="baqueiraBackground">
        <AppBaqueiraHeader />
        <div className="nm-page">

          {/* Timer banner */}
          <div className={this.getTimerClass()}>
            <div className="bq-timer-left">
              <CreditCard className="bq-timer-icon" size={20} />
              <span className="bq-timer-label">{t('Tiempo para confirmar el pago')}</span>
            </div>
            <span className="bq-timer-count">
              {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
            </span>
          </div>

          {/* Main card */}
          <div className="bq-form">
            <div className="bq-pay-card-inner">

              {/* Left: booking summary */}
              <div className="bq-pay-card-left">
                <FileCheck className="bq-form-icon" strokeWidth={1} />
                <p style={{ textAlign: 'center', fontSize: '0.88rem', color: '#6b7280', margin: '0 0 12px' }}>
                  {t('Revisa los datos de tu reserva')}
                </p>

                <div className="bq-pay-fields">
                  <div className="bq-pay-field">
                    <span className="bq-pay-field-label">{t('Zona')}</span>
                    <span className="bq-pay-field-value">{descriptionZone}</span>
                  </div>
                  <div className="bq-pay-field">
                    <span className="bq-pay-field-label">{t('Taquilla')}</span>
                    <span className="bq-pay-field-value">{this.getLockerType(selectedLocker)}</span>
                  </div>
                  <div className="bq-pay-field">
                    <span className="bq-pay-field-label">{t('Cantidad')}</span>
                    <span className="bq-pay-field-value">{lockerCount}</span>
                  </div>
                  <div className="bq-pay-field">
                    <span className="bq-pay-field-label">{t('Inicio')}</span>
                    <span className="bq-pay-field-value">{startDate ? startDate.toLocaleDateString() : ''}</span>
                  </div>
                  <div className="bq-pay-field">
                    <span className="bq-pay-field-label">{t('Fin')}</span>
                    <span className="bq-pay-field-value">{endDate ? endDate.toLocaleDateString() : ''}</span>
                  </div>
                  <div className="bq-pay-field">
                    <span className="bq-pay-field-label">{t('Hora Límite')}</span>
                    <span className="bq-pay-field-value">23:59</span>
                  </div>
                  <div className="bq-pay-field">
                    <span className="bq-pay-field-label">{t('Nombre')}</span>
                    <span className="bq-pay-field-value">{customerName}</span>
                  </div>
                  <div className="bq-pay-field">
                    <span className="bq-pay-field-label">{t('Email')}</span>
                    <span className="bq-pay-field-value">{mail}</span>
                  </div>
                  <div className="bq-pay-field">
                    <span className="bq-pay-field-label">{t('Teléfono')}</span>
                    <span className="bq-pay-field-value">+{phoneNumber}</span>
                  </div>
                </div>
              </div>

              <div className="bq-pay-col-sep" />

              {/* Right: price + pay button */}
              <div className="bq-pay-card-right">
                <CreditCard className="bq-form-icon" strokeWidth={1} />
                <p style={{ textAlign: 'center', fontSize: '0.88rem', color: '#6b7280', margin: '0 0 12px' }}>
                  {t('Confirma los importes')}
                </p>

                {discountApplied && (
                  <div className="bq-pay-price-row">
                    <span className="bq-pay-price-label">{t('Importe Original')}</span>
                    <span className="bq-pay-price-value">{originalPrice.toFixed(2)} €</span>
                  </div>
                )}
                {discountApplied && appliedRule && (
                  <div className="bq-pay-price-row">
                    <span className="bq-pay-price-label">{t('Descuento')} ({appliedRule.DiscountPercentage}%)</span>
                    <span className="bq-pay-price-value bq-pay-discount-value">−{discountAmount.toFixed(2)} €</span>
                  </div>
                )}

                <div className="bq-pay-price-row">
                  <span className="bq-pay-price-label">{t('Base')}</span>
                  <span className="bq-pay-price-value">{importeBase} €</span>
                </div>
                <div className="bq-pay-price-row">
                  <span className="bq-pay-price-label">{t('IVA')} ({iva}%)</span>
                  <span className="bq-pay-price-value">{importeIva} €</span>
                </div>

                <div className="bq-pay-price-total-row">
                  <span className="bq-pay-price-total-label">{t('Total')}</span>
                  <span className="bq-pay-price-total-amount">{total} €</span>
                </div>

                {this.redsysForm()}
              </div>
            </div>
          </div>

          {/* Edit data / cancel actions */}
          <div className="bq-pay-actions-card">
            <p className="bq-pay-actions-hint">{t('¿Necesitas cambiar algo?')}</p>
            <div className="bq-pay-actions-row">
              <button className="bq-pay-action-edit" onClick={() => this.goToPhoneView()}>
                ✏️ {t('Cambiar datos')}
              </button>
              <button className="bq-pay-action-cancel" onClick={() => this.setState({ showExitDialog: true })}>
                ✕ {t('Cancelar')}
              </button>
            </div>
          </div>

        </div>
        <StepBarBaqueira step={4} />

        {isTimeUp && this.renderTimeoutDialog()}
        {showExitDialog && !isTimeUp && this.renderExitDialog()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: true,
  redsys: state.redsys,
})

const mapDispatchToProps = dispatch => ({
  push:          bindActionCreators(push, dispatch),
  postRedsys:    bindActionCreators(postRedsys, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(PaymentBaqueiraView))
